export const CampaignSummaryReports = (builder) => ({
    CampaignSummaryReports: builder.mutation({
        query: ({ page, limit, search, startDate, endDate, campaignType }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/campaignSummary',
                method: 'GET',
                params: { page, limit, search, startDate, endDate, campaignType },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});